export default "__VITE_ASSET__rbnxiS4q__"